import requestConfig from 'config/requestExodus';

const request = requestConfig();

const GET_SEARCH_ITEM = '/glossary';
const GET_SEARCH_ITEM_DETAIL = '/glossary';
const GET_ITEM_BY_LETTER = '/glossary/letter';

const getSearchItem = (keyword: string) => {
  let params = {};

  if (keyword) {
    params = { keyword };
  }

  return request.get(GET_SEARCH_ITEM, { params });
};

const getItemDetail = (glossaryLink: string) =>
  request.get(`${GET_SEARCH_ITEM_DETAIL}/${glossaryLink}`);

const getItemByLetter = (letter: string) =>
  request.get(`${GET_ITEM_BY_LETTER}/${letter}`);

export { getSearchItem, getItemByLetter, getItemDetail };
